import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./app/theme";

import App from "./App";
import { DataStoreProvider } from "./dataStore";
import PublicBootstrapGate from "./components/PublicBootstrapGate";

// IMPORTANT: create client BEFORE DataStoreProvider runs (see logo fix below)
import Client from "./components/Client";
window.client = new Client();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DataStoreProvider>
        <PublicBootstrapGate>
          <App />
        </PublicBootstrapGate>
      </DataStoreProvider>
    </ThemeProvider>
  </React.StrictMode>
);
